/**
 * @author Titus Wormer
 * @copyright 2015 Titus Wormer
 * @license MIT
 * @module mdast:toc
 * @fileoverview Generate a Table of Contents (TOC) from a given Markdown file.
 */

'use strict';

/* Expose. */
module.exports = require('./lib/index.js');



//////////////////
// WEBPACK FOOTER
// ../~/mdast-util-toc/index.js
// module id = 572
// module chunks = 0